import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { GetLocalStroge, SetLocalStroge } from '../functions/local-storage.function';
import { CommonService } from '../services/common.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

  constructor(
    private router: Router, private commonService: CommonService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const { token } = GetLocalStroge('login');

    const apiReq = request.clone({
      headers: new HttpHeaders({
        // 'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
        'Accept-Language': 'fa',
      })
    });
    return next.handle(apiReq).pipe(
      catchError((error) => {
        this.commonService.changeStateLodding(false);
        if (error.error.token) {

          SetLocalStroge('login', { token: error.error.token });
        }
        if (error.statusCode === 401) {
          this.router.navigate(['/login']);
        }
        return throwError(error);
      }),
      tap((event) => {
        if (event instanceof HttpResponse) {
          SetLocalStroge('login', { token: event.body.token });
        }
      })
    );
  }
}
